import * as React from "react";
import { Image, Tooltip, Text } from "@fluentui/react-northstar";
import appLogo from "../../../web/assets/images/logo.png";
import msAppLogo from "../../../web/assets/images/ms-logo.png";
import infoicon from "../../../web/assets/images/info-icon.svg";

export const LogoComponent = () => {
  return <Image fluid src={appLogo} className="appLogo" />;
};

export const MSLogoComponent = () => {
  return <Image fluid src={msAppLogo} className="msLogo" />;
};

export const InfoComponent = ({ content }) => {
  return (
    <div className="infoWrapper">
      <Tooltip trigger={<Image src={infoicon} />} content={content} />
      <Text content={content} className="contentWrapper"/>
    </div>
  );
};

export const HelpComponent = ({ helpContent, supportEmail, emailUs, visitUs, content }) => {
  return (
    <div className="grey-background mg-t-1rem pd-left-info-wrapper">
      <div className="infoWrapper">
        <Image src={infoicon} />
        <p className="mg-t-1rem">
          {content}
          <span>
            <a
              href={`mailto:${supportEmail}`}
              className="text-decoration-none link-blue"
            >
              {" "}
              {emailUs}
            </a>
            .
          </span>
        </p>
      </div>
      <div className="text-decoration-none infoWrapper">
        <span className="contentWrapper padding-info-wrapper">
            {helpContent} {" "}
          <a
            href="https://www.biworldwide.com/employee-engagement/"
            target="_blank"
            className="text-decoration-none link-blue"
          >
            {visitUs}
          </a>
        </span>
      </div>
    </div>
  );
};
